import {
  Avatar,
  Card,
  CardContent,
  Grid,
  LinearProgress,
  Typography
} from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { InsertChart as InsertChartIcon } from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
  root: { height: '100%' },
  content: {
    alignItems: 'center',
    display: 'flex'
  },
  title: { fontWeight: 700 },
  avatar: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    height: 56,
    width: 56
  },
  icon: {
    height: 32,
    width: 32
  },
  progress: { marginTop: theme.spacing(3) }
}));

const TotalProjetosTemporarios = props => {
  const { className, ...rest } = props;
  const classes = useStyles();

  return (
    <Card
      {...rest}
      className={clsx(
        classes.root,
        className
      )}
    >
      <CardContent>
        <Grid
          container
          justifyContent="space-between"
        >
          <Grid item>
            <Typography
              className={classes.title}
              color="textSecondary"
              gutterBottom
              variant="body2"
            >
              PROJETOS TEMPORARIOS
            </Typography>

            <Typography variant="h3">
              {rest.totalPercProjTemp}%
            </Typography>
          </Grid>

          <Grid item>
            <Avatar className={classes.avatar}>
              <InsertChartIcon
                className={classes.icon}
              />
            </Avatar>
          </Grid>
        </Grid>

        <LinearProgress
          className={classes.progress}
          value={rest.totalPercProjTemp}
          variant="determinate"
        />
      </CardContent>
    </Card>
  );
};

TotalProjetosTemporarios.propTypes = {
  className: PropTypes.string
};

export default TotalProjetosTemporarios;